var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
export const RouteLevelContext = createContext({
    match: null,
    params: {},
});
export const RouteLevelProvider = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (_jsx(RouteLevelContext.Provider, { value: props, children: children }));
};
export const RouteGlobalContext = createContext({
    rootMatch: null,
    path: '',
    transitioning: false,
    events: new EventTarget(),
});
export const RouteGlobalProvider = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (_jsx(RouteGlobalContext.Provider, { value: props, children: children }));
};
export function useRootMatch() {
    const { rootMatch } = useContext(RouteGlobalContext);
    return rootMatch;
}
export function useLocationPath() {
    const { path } = useContext(RouteGlobalContext);
    return path;
}
export function useEvents() {
    const { events } = useContext(RouteGlobalContext);
    return events;
}
//# sourceMappingURL=context.js.map